module.exports = __webpack_public_path__ + "img/44.9def4c67.jpg";